import { render, staticRenderFns } from "./AssignPermissionToRoleModal.vue?vue&type=template&id=b0c9be92&scoped=true"
import script from "./AssignPermissionToRoleModal.vue?vue&type=script&lang=ts"
export * from "./AssignPermissionToRoleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c9be92",
  null
  
)

export default component.exports